import styled from "@emotion/styled"
import { Grid } from "@material-ui/core"

const Line = styled(Grid)(
  {
    height: "1px",
    background: "gray",
    margin: "0 auto",
    animation: "0.5s shrink forwards",
    opacity: 0.2,
  },
  props => ({
    width: props.width,
  })
)

export default Line
